import React from 'react';
import {useTranslation} from 'react-i18next';
import {TShow} from '../../../../hooks/useShow';
import SheetShell from '../SheetShell/SheetShell';
import * as css from './AdditionalInfoSheet.css';
import sanitizeHtml from '../../../../library/sanitizeHtml';

interface AdditionalInfoSheetProps {
    additionalInfo: string;
    customFields: {
        title: string;
        value: string;
    }[];
    show: TShow;
}

/* Rendered via a portal to <body>: the card is scaled with a CSS transform, which would otherwise
   become the containing block for this fixed/absolute popup and scale + mis-position it. */
function AdditionalInfoSheet({additionalInfo, customFields, show}: AdditionalInfoSheetProps): React.ReactElement | null {
    const {t} = useTranslation('eTicket');

    return (
        <SheetShell show={show} title={t('moreInfo')} data-cy="more-info-sheet">
            <css.infoContainer>
                {additionalInfo && <css.info dangerouslySetInnerHTML={sanitizeHtml(additionalInfo)} />}
                {customFields?.map((field) => (
                    <css.infoItem key={field.title}>
                        <css.infoTitle>{field.title}</css.infoTitle>
                        <css.infoValue>{field.value}</css.infoValue>
                    </css.infoItem>
                ))}
            </css.infoContainer>
        </SheetShell>
    );
}

export default AdditionalInfoSheet;
